<template>
  <span class="mc-liveview-setting">
    <i class="mc-fa icon-outline_settings" v-b-modal.select_options></i>

    <b-modal
      target="select_options"
      id="select_options"
      :show.sync="popoverShow"
      ref="select_options"
      size="sm"
      :modal-class="
        $store.state.sidebar.sideBarOpen ? 'mc-modal-options' : `mc-modal-options mc-panel-close`
      "
      hide-header
      hide-footer
      scrollable
      no-close-on-backdrop
      hide-backdrop
      no-enforce-focus
      centered
      @show="onShow"
    >
      <h4 class="mc-modal-info__head">
        {{ $t('global.object.configuration') }}
        <i class="mc-fa icon-outline_close" @click="close"></i>
      </h4>

      <div class="mc-modal-info__options">
        <p class="mc-modal-info__options-title mb-1">{{ $t('liveView.configuration.mapView') }}</p>
        <div class="mc-modal-info__options-item">
          <div class="mc-modal-info__options-item-wrapper">
            <b-row>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input type="checkbox" v-model="form.geo" @change="setting()" />
                  <label>
                    <img src="@/assets/images/map/map-geo.png" alt />
                  </label>
                  <span>{{ $t('global.object.geolocation') }}</span>
                </div>
              </b-col>
              <b-col
                md="6"
                v-if="
                  $store.state.map.infoWindow.type === 'fleet' && $store.state.map.type === 'fleet'
                "
              >
                <div class="mc-modal-info__options-item-custom-check">
                  <input type="checkbox" v-model="form.fleetCluster" @change="setting()" />
                  <label>
                    <img src="@/assets/images/map/map-cluster.png" alt />
                  </label>
                  <span>{{ $t('liveView.configuration.fleetCluster') }}</span>
                </div>
              </b-col>
              <b-col
                md="6"
                v-if="
                  $store.state.map.infoWindow.type === 'fleet' && $store.state.map.type === 'fleet'
                "
              >
                <div class="mc-modal-info__options-item-custom-check">
                  <input type="checkbox" v-model="form.traffic" @change="setting()" />
                  <label>
                    <img src="@/assets/images/map/map-traffic.png" alt />
                  </label>
                  <span>{{ $t('liveView.configuration.traffic') }}</span>
                </div>
              </b-col>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input type="checkbox" v-model="form.location_google" @change="setting()" />
                  <label>
                    <img src="@/assets/images/map/map-google.png" alt />
                  </label>
                  <span>{{ $t('liveView.configuration.googleLocation') }}</span>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <p class="mc-modal-info__options-title mb-1">{{ $t('liveView.configuration.mapType') }}</p>
        <div class="mc-modal-info__options-item">
          <div class="mc-modal-info__options-item-wrapper">
            <b-row>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    type="radio"
                    v-model="form.mapMode"
                    @change="setting()"
                    name="mapview"
                    value="roadmap"
                  />
                  <label>
                    <img src="@/assets/images/map/map-def.png" alt />
                  </label>
                  <span>Default</span>
                </div>
                <div
                  class="form-check form-switch mc-modal-info__options-item-custom-check-type"
                  v-if="form.mapMode === 'roadmap'"
                >
                  <label class="form-check-label">{{ $t('liveView.configuration.terrain') }}</label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="check-button"
                    switch
                    v-model="form.mapModeMedan"
                    @change="setting()"
                  />
                </div>
              </b-col>
              <b-col md="6">
                <div class="mc-modal-info__options-item-custom-check">
                  <input
                    type="radio"
                    v-model="form.mapMode"
                    @change="setting()"
                    name="mapview"
                    value="satellite"
                  />
                  <label>
                    <img src="@/assets/images/map/map-satelite.png" alt />
                  </label>
                  <span>{{ $t('liveView.configuration.satellite') }}</span>
                </div>
                <div
                  class="form-check form-switch mc-modal-info__options-item-custom-check-type"
                  v-if="form.mapMode === 'satellite'"
                >
                  <label class="form-check-label">{{
                    $t('liveView.configuration.mapLabel')
                  }}</label>
                  <input
                    class="form-check-input"
                    type="checkbox"
                    name="check-button"
                    v-model="form.mapModeLabel"
                    @change="setting()"
                    switch
                  />
                </div>
              </b-col>
            </b-row>
          </div>
        </div>

        <template
          v-if="$store.state.map.infoWindow.type === 'fleet' && $store.state.map.type === 'fleet'"
        >
          <div class="form-check form-switch mb-1">
            <label class="form-check-label">{{ $t('liveView.configuration.fleetLabel') }}</label>
            <input
              class="form-check-input"
              type="checkbox"
              v-model="form.label_all"
              @change="settingAll()"
              name="check-button"
              switch
            />
          </div>
          <div class="mc-modal-info__options-item">
            <div v-if="isOwnedOrder" class="form-check form-switch mb-1">
              <label class="form-check-label">{{ $t('global.object.hullNo') }}</label>
              <input
                class="form-check-input"
                type="checkbox"
                @change="setting()"
                v-model="form.label_hull"
                switch
              />
            </div>
            <div class="form-check form-switch mb-1">
              <label class="form-check-label">{{ $t('global.object.licensePlate') }}</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form.label_plate"
                @change="setting()"
                switch
              />
            </div>
            <div class="form-check form-switch mb-1">
              <label class="form-check-label">{{ $t('global.object.driverName') }}</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form.label_driver"
                @change="setting()"
                switch
              />
            </div>
            <div v-if="isOwnedOrder" class="form-check form-switch">
              <label class="form-check-label">{{
                $t('liveView.configuration.gpsInformation')
              }}</label>
              <input
                class="form-check-input"
                type="checkbox"
                v-model="form.label_gps"
                @change="setting()"
                switch
              />
            </div>
          </div>
        </template>

        <div class="form-check form-switch mb-2">
          <label class="form-check-label">{{ $t('liveView.configuration.geofenceLabel') }}</label>
          <input
            class="form-check-input"
            type="checkbox"
            v-model="form.label_marker"
            @change="setting()"
            name="check-button"
            switch
          />
        </div>

        <template
          v-if="
            $store.state.map.infoWindow.type === 'fleet' &&
            $store.state.map.type === 'fleet' &&
            isOwnedOrder
          "
        >
          <p class="mc-modal-info__options-title">{{ $t('liveView.configuration.gpsSource') }}</p>
          <div class="mc-modal-info__options-item">
            <div class="form-check form-switch">
              <label class="form-check-label">{{ $t('global.object.fleet') }}</label>
              <input
                class="form-check-input"
                type="checkbox"
                @change="setting()"
                name="check-button"
                switch
                v-model="form.gpsSource"
                disabled
              />
            </div>
          </div>
        </template>
      </div>
    </b-modal>
  </span>
</template>

<script>
import { mapActions } from 'vuex'
import responsive from '@/mixin/responsive'
import { Helper } from '@/mixin/helper'
import { mapState } from 'vuex'

export default {
  name: 'RBSelectOptions',
  mixins: [Helper, responsive],
  data() {
    return {
      form: {
        geo: false,
        traffic: false,
        auto_reload: true,
        fleetCluster: true,
        label_plate: true,
        label_driver: false,
        label_hull: false,
        label_gps: false,
        label_marker: true,
        location_google: true,
        label_all: true,
        gpsSource: true,
        mapMode: 'roadmap',
        mapModeMedan: false,
        mapModeLabel: true,
      },

      popoverShow: false,
      timer: 0,
    }
  },
  computed: {
    ...mapState('map', ['fleetOrder']),
    isOwnedOrder() {
      // this condition for the owned order and others, expect vendor's order
      return (this.fleetOrder && this.fleetOrder.id) || this.fleetOrder === null
    },
  },
  async created() {
    this.$store.commit('fleets/loadingKendaraan', true)

    const self = this

    this.$root.$on('setSelectOptions', function (type, param) {
      self.setSelectOptions(type, param)
    })

    if (localStorage.getItem('geo') === null) localStorage.setItem('geo', this.form.geo)

    if (localStorage.getItem('traffic') === null) localStorage.setItem('traffic', this.form.traffic)

    if (localStorage.getItem('auto_reload') === null)
      localStorage.setItem('auto_reload', this.form.auto_reload)

    if (localStorage.getItem('fleetCluster') === null)
      localStorage.setItem('fleetCluster', this.form.fleetCluster)

    if (localStorage.getItem('label_all') === null)
      localStorage.setItem('label_all', this.form.label_all)

    if (localStorage.getItem('label_plate') === null)
      localStorage.setItem('label_plate', this.form.label_plate)

    if (localStorage.getItem('label_driver') === null)
      localStorage.setItem('label_driver', this.form.label_driver)

    if (localStorage.getItem('label_hull') === null)
      localStorage.setItem('label_hull', this.form.label_hull)

    if (localStorage.getItem('label_gps') === null)
      localStorage.setItem('label_gps', this.form.label_gps)

    if (localStorage.getItem('label_marker') === null)
      localStorage.setItem('label_marker', this.form.label_marker)

    if (localStorage.getItem('location_google') === null)
      localStorage.setItem('location_google', this.form.location_google)

    if (localStorage.getItem('mapMode') === null) localStorage.setItem('mapMode', this.form.mapMode)

    if (localStorage.getItem('mapModeMedan') === null)
      localStorage.setItem('mapModeMedan', this.form.mapModeMedan)

    if (localStorage.getItem('mapModeLabel') === null)
      localStorage.setItem('mapModeLabel', this.form.mapModeLabel)

    this.form.geo = JSON.parse(localStorage.getItem('geo'))
    this.$store.commit('fleets/geoStatus', JSON.parse(localStorage.getItem('geo')))

    this.form.traffic = JSON.parse(localStorage.getItem('traffic'))

    this.form.fleetCluster = JSON.parse(localStorage.getItem('fleetCluster'))
    this.$store.commit('fleets/fleetCluster', JSON.parse(this.form.fleetCluster))

    this.form.label_all = JSON.parse(localStorage.getItem('label_all'))
    this.$store.commit('fleets/markerAll', JSON.parse(localStorage.getItem('label_all')))

    this.form.label_plate = JSON.parse(localStorage.getItem('label_plate'))
    this.$store.commit('fleets/markerPlate', JSON.parse(localStorage.getItem('label_plate')))

    this.form.label_driver = JSON.parse(localStorage.getItem('label_driver'))
    this.$store.commit('fleets/markerDriver', JSON.parse(localStorage.getItem('label_driver')))

    this.form.label_hull = JSON.parse(localStorage.getItem('label_hull'))
    this.$store.commit('fleets/markerHull', JSON.parse(localStorage.getItem('label_hull')))

    this.form.label_gps = JSON.parse(localStorage.getItem('label_gps'))
    this.$store.commit('fleets/markerGps', JSON.parse(localStorage.getItem('label_gps')))

    this.form.label_marker = JSON.parse(localStorage.getItem('label_plate'))
    this.$store.commit('fleets/markerPlateLabel', JSON.parse(localStorage.getItem('label_plate')))

    this.form.location_google = JSON.parse(localStorage.getItem('location_google'))

    this.form.mapMode = localStorage.getItem('mapMode')
    if (this.form.mapMode === 'roadmap') {
      this.$store.commit(
        'fleets/mapMode',
        this.form.mapModeMedan ? 'terrain' : localStorage.getItem('mapMode')
      )
    } else {
      this.form.mapModeLabel = JSON.parse(localStorage.getItem('mapModeLabel'))
    }

    this.form.mapModeLabel = JSON.parse(localStorage.getItem('mapModeLabel'))
    this.form.mapModeMedan = JSON.parse(localStorage.getItem('mapModeMedan'))

    if (this.form.mapMode === 'roadmap') {
      this.$store.commit(
        'fleets/mapMode',
        this.form.mapModeMedan ? 'terrain' : localStorage.getItem('mapMode')
      )
    } else {
      this.$store.commit(
        'fleets/mapMode',
        this.form.mapModeLabel ? 'hybrid' : localStorage.getItem('mapMode')
      )
    }
    if (this.$store.state.map.type === 'fleetOrder') {
      this.form.geo = true
      this.form.fleetCluster = false
    }
  },
  methods: {
    onShow() {
      if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
        this.$store.commit('sidebar/toggleSideBar')
      }

      if (document.getElementById('modal-history')) {
        document.getElementById('modal-history').classList.add('mc-history-modal--open-setting')
      }

      if (document.getElementById('modal-assignment')) {
        document.getElementById('modal-assignment').classList.add('mc-history-modal--open-setting')
      }
      this.$bvModal.hide('modal-filter')
      this.$bvModal.hide('modal-filter-geofence')
      this.$bvModal.hide('modal-filter-alert')
      this.$bvModal.hide('modal-info')
    },

    close() {
      this.$bvModal.hide('select_options')
      if (this.mediaQuery.matches && this.$store.state.sidebar.sideBarOpen) {
        this.$store.commit('sidebar/toggleSideBar')
      }
      if (document.getElementById('modal-history')) {
        document.getElementById('modal-history').classList.remove('mc-history-modal--open-setting')
      }
      if (document.getElementById('modal-assignment')) {
        document
          .getElementById('modal-assignment')
          .classList.remove('mc-history-modal--open-setting')
      }
      /**
       * If the user has opened the "Detail Kendaraan" modal before,
       * then show the "Detail Kendaraan" modal if the user close the "Setting Map" modal
       */
      if (this.$store.state.map.infoWindow.detail?.vehicleId) {
        this.$bvModal.hide('modal-info')
      } else if (
        !this.$store.state.map.infoWindow.detail?.vehicleId &&
        this.$store.state.map.type === 'fleetOrder'
      ) {
        this.$store.commit('map/TYPE_OF_MAP', 'fleet')
      }
    },

    ...mapActions('fleets', ['requestFleets']),

    onClose() {
      this.popoverShow = false
    },

    setSelectOptions(type, param) {
      this.form[type] = param
      localStorage.setItem(type, this.form[type])
    },

    settingAll() {
      localStorage.setItem('label_all', this.form.label_all)
      this.$store.commit('fleets/markerAll', this.form.label_all)

      localStorage.setItem('label_plate', this.form.label_all)
      this.$store.commit('fleets/markerPlate', this.form.label_all)
      this.$store.commit('fleets/markerPlateLabel', this.form.label_all)

      this.form.label_plate = this.form.label_all

      localStorage.setItem('label_driver', this.form.label_all)
      this.$store.commit('fleets/markerDriver', this.form.label_all)

      this.form.label_driver = this.form.label_all

      localStorage.setItem('label_hull', this.form.label_all)
      this.$store.commit('fleets/markerHull', this.form.label_all)

      this.form.label_hull = this.form.label_all

      localStorage.setItem('label_gps', this.form.label_all)
      this.$store.commit('fleets/markerGps', this.form.label_all)

      this.form.label_gps = this.form.label_all

      this.$root.$emit('SettingSelectOptions')
      this.$root.$emit('SettingSelectOptionsHistory')
    },

    setting() {
      localStorage.setItem('geo', this.form.geo)
      this.$store.commit('fleets/geoStatus', JSON.parse(localStorage.getItem('geo')))

      localStorage.setItem('fleetCluster', this.form.fleetCluster)
      this.$store.commit('fleets/fleetCluster', JSON.parse(localStorage.getItem('fleetCluster')))

      localStorage.setItem('label_plate', this.form.label_plate)
      this.$store.commit('fleets/markerPlateLabel', JSON.parse(localStorage.getItem('label_plate')))

      localStorage.setItem('label_driver', this.form.label_driver)
      this.$store.commit('fleets/markerDriver', JSON.parse(localStorage.getItem('label_driver')))

      localStorage.setItem('label_hull', this.form.label_hull)
      this.$store.commit('fleets/markerHull', JSON.parse(localStorage.getItem('label_hull')))

      localStorage.setItem('label_gps', this.form.label_gps)
      this.$store.commit('fleets/markerGps', JSON.parse(localStorage.getItem('label_gps')))

      localStorage.setItem('label_marker', this.form.label_marker)
      this.$store.commit('fleets/markerLabel', JSON.parse(localStorage.getItem('label_marker')))

      localStorage.setItem('location_google', this.form.location_google)
      localStorage.setItem('traffic', this.form.traffic)
      localStorage.setItem('mapModeLabel', this.form.mapModeLabel)
      localStorage.setItem('mapModeMedan', this.form.mapModeMedan)
      localStorage.setItem('mapMode', this.form.mapMode)

      if (this.form.mapMode === 'roadmap') {
        this.$store.commit(
          'fleets/mapMode',
          this.form.mapModeMedan ? 'terrain' : localStorage.getItem('mapMode')
        )
      } else {
        this.$store.commit(
          'fleets/mapMode',
          this.form.mapModeLabel ? 'hybrid' : localStorage.getItem('mapMode')
        )
      }

      this.$root.$emit('SettingSelectOptions')
      this.$root.$emit('SettingSelectOptionsHistory')
      this.$root.$emit('SettingSelectOptionsFleetOrder')
    },
  },
}
</script>
